import React, { useState, useEffect, useRef, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaHome, FaUserMd, FaHospitalUser, FaInfoCircle, FaPhone, FaTimes } from "react-icons/fa";
import "./Navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [hideHeader, setHideHeader] = useState(false);
  const lastScroll = useRef(0);
  const location = useLocation();

  const navbarLinks = useMemo(
    () => [
      { to: "/", icon: <FaHome />, text: "Home" },
      { to: "/about", icon: <FaInfoCircle />, text: "About Us" },
      { to: "/services", icon: <FaHospitalUser />, text: "Medical Services" },
      { to: "/gallery-full", icon: <FaUserMd />, text: "Gallery" },
      { to: "/contact", icon: <FaPhone />, text: "Get In Touch" },
    ],
    []
  );

  // Hide HEADER on scroll
  useEffect(() => {
    const handleScroll = () => {
      const current = window.scrollY;

      if (current > lastScroll.current && current > 60) {
        setHideHeader(true);
      } else {
        setHideHeader(false);
      }

      lastScroll.current = current;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Lock body when sidebar open
  useEffect(() => {
    document.body.classList.toggle("sidebar-open", menuOpen);
  }, [menuOpen]);

  // Close sidebar when route changes
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);
// Wait until Google Translate dropdown exists
const changeLanguage = (lang) => {
  const interval = setInterval(() => {
    const select = document.querySelector(".goog-te-combo");
    if (select) {
      clearInterval(interval);

      // Change value and dispatch events twice to trigger translation
      select.value = lang;
      select.dispatchEvent(new Event("change"));
      select.dispatchEvent(new Event("change"));

      // Focus/blur to make Google Translate register immediately
      select.focus();
      select.blur();
    }
  }, 200);
};

  return (
    <>
      {/* ⭐ TOP HEADER (Black) */}
      <div className={`top-header ${hideHeader ? "hide-header" : ""}`}>
        <div className="top-header-container">

          <div className="top-left">
            🏥📞Emergency Helpline:<br></br><a href="tel:+91 7249693033">+91 7249693033</a>
          </div>

        <div className="translator">
  <button className="lang-btn" onClick={() => changeLanguage("en")}>
    English
  </button>

  <button className="lang-btn" onClick={() => changeLanguage("mr")}>
    Marathi
  </button>
</div>

        </div>
      </div>

      {/* Overlay */}
      <div
        className={`overlay ${menuOpen ? "show" : ""}`}
        onClick={() => setMenuOpen(false)}
      />

      {/* ⭐ NAVBAR (moves down when header visible) */}
      <nav className={`navbar ${hideHeader ? "shift-up" : "shift-down"}`}>
        <div className="navbar-container">
          <div className="navbar-logo">
            <Link to="/" onClick={() => setMenuOpen(false)}>
              <img src="./images/lg.webp" alt="Hospital Logo" />
            </Link>
          </div>

          <div className="hamburger" onClick={() => setMenuOpen(true)}>
            ☰
          </div>

          <ul className="navbar-menu">
            {navbarLinks.map((link, i) => (
              <li key={i}>
                <Link to={link.to} className="navbar-link">
                  {link.text}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </nav>

      {/* Sidebar */}
      <div className={`sidebar ${menuOpen ? "open" : ""}`}>
        <div className="sidebar-close" onClick={() => setMenuOpen(false)}>
          <FaTimes />
        </div>

        <div className="sidebar-logo">
          <Link to="/" onClick={() => setMenuOpen(false)}>
            <img src="./images/lg.webp" alt="Hospital Logo" />
          </Link>
        </div>

        <ul className="sidebar-links">
          {navbarLinks.map((link, i) => (
            <li key={i}>
              <Link to={link.to} onClick={() => setMenuOpen(false)}>
                {link.icon} {link.text}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Navbar;
